import React from 'react';
import * as PropTypes from 'prop-types';

const H2 = ({ children, fontSize }) => (
  <>
    <h2>{children}</h2>
    <style jsx>
      {`
        h2 {
          font-family: Arial, Helvetica, sans-serif;
          font-weight: normal;
          margin: 0;
          font-size: ${fontSize};
        }
      `}
    </style>
  </>
);

H2.propTypes = {
  children: PropTypes.node.isRequired,
  fontSize: PropTypes.string,
};

H2.defaultProps = {
  fontSize: '28px',
};

export default H2;
